export default __webpack_public_path__ + "static/media/ed2mit2020hwa02-mapreduce-pregel.1389708e.pdf";